import {
    GET_MAIN_BUNNER,
    GET_MAIN_CATEGORIES,
    GET_ONE_PRODUCT,
    GET_CATEGORIES,
    GET_CATEGORY,
    GET_ALL_PRODUCTS,
    GET_ADD_TO_CART,
    GET_ORDER_CART,
    GET_SHOP_ORDER_NUMBER,
    GET_ADD_COUNTER_CART,
    GET_MINUS_COUNTER_CART,
    GET_DELETE_CART,
    GET_CHANGE_PRODUCT_QUANTITY,
    GET_SHOP_PRODUCTS_SEARCH,
    SET_ORDER_BRANCH_SAVE,
    GET_COME_TO_PAY
} from "../../resources/js/helpers/requests"

export default {
     state: {
    headerCategodies: [],
    perPage: '',
    openProduct: {},
    allCategodies: [],
    products: [],
    mainBanners: [],
    isShowProducts: 'category',
    perCategoris: [],
    max_price: 0,
    customerCart: {},
    order_id: null,
    searchText: '',
    filterParametrs: {},
    checkedCategory: null,
    customCustomerInfo: {
      firstName: null,
      lastName: null,
      phoneNumber: null,
    }
  },
  mutations: {
    updateMainCategories(state, category) {
        state.headerCategodies = category
    },
    updateBanners(state, banners) {
        state.mainBanners = banners
    },
   addPerPage(state, page) {
    state.perPage = page
   },
   setIsOpenProductInfo(state, product) {
    state.openProduct = product
   },
   getAllCategories(state, categories) {
    state.allCategodies = categories
   },
   setIsShowProducts(state, value) {
    state.isShowProducts = value
   },
   setAddPerCategory(state, category) {
    state.perCategoris = category
   },
   setAddProducts(state, products) {
    state.products = products
   },
   setAddMaxPrice(state, price) {
    state.max_price = price
   },
   setAddProductToCart(state, product) {
    state.customerCart = product
   },
   setOrderId(state, id) {
    state.order_id = id
   },
   setChangeSearchText(state, text) {
    state.searchText = text
   },
   setFilterParametrs(state, data) {
    state.filterParametrs = data
   },
   deleteFilterCategoryParametr(state) {
      state.filterParametrs = delete state.filterParametrs.category_ids
   },
   setFilterPriceParametrs(state, data) {
     state.filterParametrs = { 
    ...state.filterParametrs,
    price_from: data.price_from,
    price_to: data.price_to
    }
    console.log({state})
   },
   deleteFilterParametr(state) {
      state.filterParametrs = {}
   },
   setCheckedCategory(state, data) {
    state.checkedCategory = data
   },
   setChangeCustomerInfo(state, data) {
    state.customCustomerInfo = data
   }
  },
  actions: {
    async getMainBunner({commit}) {
        let result = await GET_MAIN_BUNNER()
        commit('updateBanners', result.data)
    },
    async getMainCategories({commit}) {
        let result = await GET_MAIN_CATEGORIES()
        commit('updateMainCategories', result.data)
    },
    async getOneProduct({commit}, id) {
      let result = await GET_ONE_PRODUCT(id)
      commit('setIsOpenProductInfo', result.data)
    },
    async allCategories({commit}) {
      let result = await GET_CATEGORIES()
      commit('getAllCategories', result.data)
    },
    // async getProductsReq({commit}, id) {
    //   let result = await GET_CATEGORY(id)
    //   if (result.data?.children.length) {
    //     commit('setIsShowProducts', 'preCategory')
    //     commit('setAddPerCategory', result.data.children)
    //   }
    //   if (result.data?.products?.length) {
    //     commit('setIsShowProducts', 'products')
    //     commit('setAddProducts', result.data.products)
    //   }
    // },
     async getProductsReq({commit}, id) {
      let result = await GET_CATEGORY(id)
      if (result.data?.children.length) {
        commit('setIsShowProducts', 'preCategory')
        commit('setAddPerCategory', result.data)
      }
      if (result.data?.products?.length) {
        commit('setIsShowProducts', 'products')
        commit('setAddProducts', result.data)
      }
    },
    async getAllProducts({commit}) {
      let result = await GET_ALL_PRODUCTS()
      commit('setAddMaxPrice', result?.max_price)
    },
    async addProductToCart({commit}, body) {
      let result = await GET_ADD_TO_CART(body)
     if (JSON.parse(body).quantity > 1) {
      let quantity = await GET_CHANGE_PRODUCT_QUANTITY(body)
        commit('setAddProductToCart', quantity.data)
      } else {
        commit('setAddProductToCart', result.data)
      }
      
    },
    async getCartProducts({commit}, id) {
      let order_id = await GET_SHOP_ORDER_NUMBER(id)
      commit('setOrderId', order_id.data)
      let result = await GET_ORDER_CART(order_id.data.id)
      commit('setAddProductToCart', result.data)
    },
   async getOneMoreProduct({commit}, data) {
    let result = await GET_ADD_COUNTER_CART(data)
    console.log({result})
    commit('setAddProductToCart', result.data)
   },
   async getMinusProduct({commit}, data) {
    let result = await GET_MINUS_COUNTER_CART(data)
    commit('setAddProductToCart', result.data)
   },
   async deleteProductFromCart({commit}, data) {
    let result = await GET_DELETE_CART(data)
    commit('setAddProductToCart', result.data)
   },
   async searchedProducts({commit}, data) {
    let result = await GET_SHOP_PRODUCTS_SEARCH(data)
    commit('setAddProducts', result.data)
    commit('setIsShowProducts', 'products')
   },
   async setSaveOrder({commit}, data) {
   let result = await SET_ORDER_BRANCH_SAVE(data)
    console.log({commit})
    return result
   },
   async setReturnToBot({commit}, data) {
    let result = await GET_COME_TO_PAY(data)
    console.log({commit})
    return result
   }
  },
  getters: {
    perPageName: state => {
        return state.perPage
    },
    allHeaderCategories: state => {
      return state.headerCategodies  
    },
    allMainBunners: state => {
        return state.mainBanners
    },
    openedProduct: state => {
      return state.openProduct
    },
    allCategories: state => {
      return state.allCategodies
    },
    isShowProducts: state => {
      return state.isShowProducts
    },
    preCategories: state => {
      return state.perCategoris
    },
    getProducts: state => {
      return state.products
    },
    getMaxPrice: state => {
      return state.max_price
    },
    getCustomerCart: state => {
      return state.customerCart
    },
    getOrderId: state => {
      return state.order_id
    },
    getSearchText: state => {
      return state.searchText
    },
    getFilterParametrs: state => {
      return state.filterParametrs
    },
    getCheckedCategory: state => {
      return state.checkedCategory
    },
    customCustomerInfo: state => {
      return state.customCustomerInfo
    }
  }
}